if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = `${theme.routes.search_url}?view=recently-viewed&type=product&q=`;
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = Number(this.dataset.max);
      this.products = '';
      this.timestampMap = {};

      const recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds) {
        let parsed = JSON.parse(recentIds);

        // Normalize and build timestamp map
        window.recentlyViewedIds = parsed.map(item => {
          if (typeof item === 'string') {
            return { handle: item, viewedAt: null };
          }
          return item;
        });

        // Build a handle → timestamp map for quick lookup
        window.recentlyViewedIds.forEach(item => {
          this.timestampMap[item.handle] = item.viewedAt;
        });
      }
    }

    connectedCallback() {
      this.buildUrl();

      const clearBtns = this.querySelectorAll('.recently-viewed-clear-all');
      clearBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearAll();
        });
      });
    }

    buildUrl() {
      const productHandles = window.recentlyViewedIds
        .filter(item => item.handle !== this.currentId)
        .slice(0, this.max);

      this.products = productHandles.map(item => `handle:${item.handle}`).join(' OR ');
      this.url += encodeURIComponent(this.products);

      this.fetchProducts();
    }

    timeAgo(timestamp) {
      if (!timestamp) return '';
      const now = Date.now();
      const diffMs = now - timestamp;
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHr = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHr / 24);
      const diffWeek = Math.floor(diffDay / 7);
      const diffMonth = Math.floor(diffDay / 30);
      const diffYear = Math.floor(diffDay / 365);

      if (diffSec < 60) return 'Just now';
      if (diffMin < 60) return diffMin === 1 ? '1 min ago' : `${diffMin} mins ago`;
      if (diffHr < 24) return diffHr === 1 ? '1 hour ago' : `${diffHr} hours ago`;
      if (diffDay < 7) return diffDay === 1 ? '1 day ago' : `${diffDay} days ago`;
      if (diffWeek < 5) return diffWeek === 1 ? '1 week ago' : `${diffWeek} weeks ago`;
      if (diffMonth < 12) return diffMonth === 1 ? '1 month ago' : `${diffMonth} months ago`;
      return diffYear === 1 ? '1 year ago' : `${diffYear} years ago`;
    }

    addTimestamps() {
      const cards = this.container.querySelectorAll('product-card');
      cards.forEach((card) => {
        const compareInput = card.querySelector('[data-product-handle]');
        if (!compareInput) return;

        const handle = compareInput.dataset.productHandle;
        const timestamp = this.timestampMap[handle];
        const timeAgoText = this.timeAgo(timestamp);

        card.style.position = 'relative';

        // Add timestamp badge
        if (timeAgoText) {
          const badge = document.createElement('div');
          badge.className = 'recently-viewed-timestamp';
          badge.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><span>Viewed ${timeAgoText}</span>`;
          const titleEl = card.querySelector('.product-card-title');
          if (titleEl) {
            titleEl.parentNode.insertBefore(badge, titleEl);
          } else {
            card.appendChild(badge);
          }
        }

        // Add remove button
        const removeBtn = document.createElement('button');
        removeBtn.className = 'recently-viewed-remove';
        removeBtn.setAttribute('aria-label', 'Remove from recently viewed');
        removeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.removeProduct(handle, card);
        });
        card.appendChild(removeBtn);
      });
    }

    sortByRecent() {
      const slides = Array.from(this.container.querySelectorAll('.carousel__slide'));

      // Sort by timestamp (most recent first)
      slides.sort((a, b) => {
        const handleA = a.querySelector('[data-product-handle]')?.dataset.productHandle;
        const handleB = b.querySelector('[data-product-handle]')?.dataset.productHandle;
        const timeA = this.timestampMap[handleA] || 0;
        const timeB = this.timestampMap[handleB] || 0;
        return timeB - timeA; // Descending order (newest first)
      });

      // Re-append in sorted order
      slides.forEach(slide => this.container.appendChild(slide));
    }

    removeProduct(handle, card) {
      // Remove from localStorage
      let data = JSON.parse(localStorage.getItem('recently-viewed')) || [];
      data = data.filter(item => {
        if (typeof item === 'string') return item !== handle;
        return item.handle !== handle;
      });
      localStorage.setItem('recently-viewed', JSON.stringify(data));

      // Update global array
      window.recentlyViewedIds = data;

      // Remove from timestamp map
      delete this.timestampMap[handle];

      // Animate and remove the card
      const slide = card.closest('.carousel__slide');
      if (slide) {
        slide.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        slide.style.opacity = '0';
        slide.style.transform = 'scale(0.95)';
        setTimeout(() => {
          slide.remove();

          // Hide section if no products left
          if (this.container.querySelectorAll('.carousel__slide').length === 0) {
            this.classList.remove('recently-viewed-products--loaded');
            const elementToShow = document.getElementById("welcome-pseudo-banner");
            if (elementToShow) {
              elementToShow.style.display = '';
            }
          }
        }, 300);
      }
    }

    clearAll() {
      localStorage.removeItem('recently-viewed');
      window.recentlyViewedIds = [];
      this.timestampMap = {};

      // Animate all cards out
      const slides = this.container.querySelectorAll('.carousel__slide');
      slides.forEach((slide, i) => {
        slide.style.transition = `opacity 0.3s ease ${i * 0.05}s, transform 0.3s ease ${i * 0.05}s`;
        slide.style.opacity = '0';
        slide.style.transform = 'scale(0.95)';
      });

      setTimeout(() => {
        this.container.innerHTML = '';
        this.classList.remove('recently-viewed-products--loaded');
        const elementToShow = document.getElementById("welcome-pseudo-banner");
        if (elementToShow) {
          elementToShow.style.display = '';
        }
      }, 300 + slides.length * 50);
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('recently-viewed-products--loaded');
            this.container.querySelectorAll('.lazyload').forEach((image) => {
              lazySizes.loader.unveil(image);
            });

            // Add timestamp badges
            this.addTimestamps();

            // Sort cards by most recently viewed
            this.sortByRecent();
          }

          const elementToHide = document.getElementById("welcome-pseudo-banner");
          if (elementToHide) {
            elementToHide.style.display = 'none';
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}